type ArrayUpdateOperations = ({ disconnect: { id: string } } | { connect: { id: string } })[];

/**
 * Decides if item should be connected, disconnected or kept in place based on passed in arrays
 */
export const determineArrayUpdateOperation = (originalArray: readonly string[], updatedArray: readonly string[]): ArrayUpdateOperations => {
	const items = [...new Set([...originalArray, ...updatedArray])];
	const arrayOfOperations: ArrayUpdateOperations = [];

	items.forEach((id) => {
		const isWithinOriginalArray = originalArray.includes(id);
		const isWithinUpdatedArray = updatedArray.includes(id);

		if (isWithinOriginalArray && !isWithinUpdatedArray) {
			arrayOfOperations.push({
				disconnect: {
					id,
				},
			});
		} else if (!isWithinOriginalArray && isWithinUpdatedArray) {
			arrayOfOperations.push({
				connect: {
					id,
				},
			});
		}
		return null;
	});

	return arrayOfOperations;
};
